import { Pipe, PipeTransform } from '@angular/core';
import { getDuration } from '@shared/dates';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {
  transform(seconds: number): string {
    return getDuration(seconds);
  }
}
